import React from 'react';

import { TimeInput } from 'components/shared/TimeInput';

const TimeInputField = ({
  field,
  form,
  ...restProps
}: { field: any; form: any } & Record<string, any>) => {
  const handleChange = (value: any) => {
    form.setFieldValue(field.name, value);
  };

  return <TimeInput {...field} {...restProps} onChange={handleChange} />;
};

export default React.memo(TimeInputField) as any;
